import { useTranslation } from "react-i18next";
import { AppStore } from "../../features/app-stores/storeLinks";
import { badgeSrc } from "../../features/app-stores/badges";

interface StoreBadgeProps {
  store: AppStore;
}

/**
 * The store's official badge as the link, unmodified. Google's artwork carries its own transparent
 * clear space, so its image is taller: at 58px its visible badge matches Apple's 40px one.
 */
const StoreBadge = ({ store }: StoreBadgeProps) => {
  const { t, i18n } = useTranslation();
  const sizeClass = store.id === "app-store" ? "h-10" : "h-[58px]";

  return (
    <a href={store.url} target="_blank" rel="noopener noreferrer" data-testid={`store-badge-${store.id}`}>
      <img src={badgeSrc(store.id, i18n.language ?? "en")} alt={t(store.badgeAltKey)} className={`${sizeClass} w-auto`} />
    </a>
  );
};

export default StoreBadge;
